import styled from "styled-components/macro";

export default styled.div`
a{
  text-decoration:none;
}
`;
